(function () {
  'use strict';

  /* ==========================================================================
     Scroll-triggered reveal — works for both .cs-card (grid) and
     .cs-bento__tile (editorial)
     ========================================================================== */

  function initReveal() {
    var items = document.querySelectorAll('.cs-card, .cs-bento__tile');
    if (!items.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    // Stagger by index, capped so later items don't feel sluggish
    items.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i, 8) * 0.06) + 's';
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );

      items.forEach(function (el) { observer.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ==========================================================================
     Marquee — duplicate items for seamless loop, set speed by item count
     ========================================================================== */

  function initMarquee() {
    var marquee = document.querySelector('.cs-marquee');
    if (!marquee) return;

    var items = marquee.querySelectorAll('.cs-marquee__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      marquee.appendChild(clone);
    });

    var speed = Math.max(28, items.length * 3.5);
    marquee.style.setProperty('--cs-marquee-speed', speed + 's');
  }

  function init() {
    initReveal();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
